/*Define validation rules
Recibe un diccionario con los nombres de los campos, sus valores
y una regla. Devuelve otro diccionario con el mensaje de error
"indexado" por el nombre del campo
*/
export enum Rule {
  REQUIRED,
  GREATER_ZERO,
  EQUAL_ZERO,
  GREATER_EQUAL_ZERO,
  LOWER_EQUAL_ZERO,
}

export interface FieldToValidate {
  name: string
  value: string | number | Date | undefined
  rule: Rule
}

// Utility function to validate fields
export const validateFields = (fields: FieldToValidate[]): { [key: string]: string } => {
  const errors: { [key: string]: string } = {}

  fields.forEach((field) => {
    const { name, value, rule } = field
    let valueAux

    if (value instanceof Date && isNaN(value.getTime())) {
      valueAux = ''
    } else {
      valueAux = value?.toString() ?? ''
    }

    // let numericValue = valueAux.replace(/[^\d]/g, ''); // Strip non-numeric characters
    // Strip non-numeric characters manteniendo el "-" inicial
    let numericValue = valueAux.replace(/(?!^-)[^\d]/g, '')

    if (!numericValue) {
      numericValue = '0'
    }
    const isNotaNumber = isNaN(Number(numericValue))
    const monto = Number(numericValue)

    switch (rule) {
      case Rule.REQUIRED:
        if (!valueAux || valueAux.trim() === '') {
          errors[name] = 'Ingrese un valor.'
        }
        break

      case Rule.GREATER_ZERO:
        if (isNotaNumber || monto <= 0) {
          errors[name] = 'Valor debe ser mayor que cero.'
        }
        break

      case Rule.EQUAL_ZERO:
        if (isNotaNumber || monto !== 0) {
          errors[name] = 'Valor debe ser igual que cero.'
        }
        break
      case Rule.GREATER_EQUAL_ZERO:
        if (isNotaNumber || monto < 0) {
          errors[name] = 'Valor debe ser mayor o igual que cero.'
        }
        break
      case Rule.LOWER_EQUAL_ZERO:
        if (isNotaNumber || monto > 0) {
          errors[name] = 'Valor debe ser menor o igual que cero.'
        }
        break
      default:
        break
    }
  })

  return errors
}
// Utility function to validate fields
export const validateNotEqual = (
  name: string,
  value: string | number,
  valueCompare: string | number,
  msg: string
): { [key: string]: string } => {
  const errors: { [key: string]: string } = {}

  // le quitamos a ambos los puntos
  const valueAux = value?.toString()
  let numericValue = valueAux.replace(/[^\d]/g, '') // Strip non-numeric characters

  if (!numericValue) {
    numericValue = '0'
  }
  const value2Aux = valueCompare?.toString()
  let numeric2Value = value2Aux.replace(/[^\d]/g, '') // Strip non-numeric characters

  if (!numeric2Value) {
    numeric2Value = '0'
  }

  if (numericValue === numeric2Value) {
    errors[name] = msg
  }

  return errors
}
export interface ComboToValidate {
  name: string
  keys: string[]
  value: string
}
export const validateCombos = (fields: ComboToValidate[]): { [key: string]: string } => {
  const errors: { [key: string]: string } = {}

  fields.forEach((field) => {
    const { name, keys, value } = field

    if (!keys.includes(value)) {
      errors[name] = 'Ingrese un valor.'
    }
  })

  return errors
}
